import {json} from '../../../../core/data-source/json.mapper';

export class OrderCommunicationsRecord {
    @json()
    dateTime: string;

    @json()
    orderReference: string;

    @json()
    type: string;

    @json()
    trigger: string;

    @json()
    to: string;

    @json()
    parts: number;

    @json()
    result: string;

    @json()
    body: string;
}
